var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item != null && _vm.col != null)?_c('span',[_vm._l((_vm.item[_vm.col]),function(period,index){return _c('v-chip',{key:index,on:{"click":_vm.onClickCell}},[_vm._v(" "+_vm._s(period)+" ")])}),(_vm.item[_vm.col] != null && _vm.item[_vm.col].length == 0)?_c('v-chip',{on:{"click":_vm.onClickCell}},[_vm._v(" Closed ")]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }